import AccountSubscriptionModel from '@models/account/AccountSubscriptionModel';
import InvoiceStatusModel       from '@models/account/InvoiceStatusModel';
import InvoiceTypeModel         from '@models/account/InvoiceTypeModel';
import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import AccountServiceModel      from '@/models/AccountServiceModel';
import { accountConnector }     from '@/models/AccountServiceModel';
import TimestampAble            from '@widesk-core/models/traits/TimestampAble';
import Blamable                 from '@/models/traits/Blamable';
import { getLocale }            from '@widesk-core/locale';
import { downloadUrl }          from '@/helpers/DownloadHelper';
import { previewUrl }           from '@/helpers/DownloadHelper';

@model.urnResource('invoice')
@doc.path('/invoices/{?id}')
export default class InvoiceModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'accountSubscription': id;
		'accountSubscription.account': id;
		'id': id;
		'invoiceStatus': id;
		'invoiceType': id;
		'number': string;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'number': string;
	};

	@doc.model(AccountSubscriptionModel) declare accountSubscription: AccountSubscriptionModel;
	@doc.number declare amountExcludingVat: number;
	@doc.number declare amountIncludingVat: number;
	@doc.number declare amountVat: number;
	@doc.string declare currency: string;
	@doc.date declare dueDate: Dayjs;
	@doc.model(InvoiceStatusModel) declare invoiceStatus: InvoiceStatusModel;
	@doc.model(InvoiceTypeModel) declare invoiceType: InvoiceTypeModel;
	@doc.string declare number: string;
	@doc.string declare taxabilityReason: string;
	@doc.string declare vatRate: string;

	public get modelLabel(): string {
		return this.number;
	}

	public get pdfUrl(): string {
		return accountConnector.getUri({ url: `${this.path}/preview`, params: { locale: getLocale() } });
	}

	public get pdfFileName(): string {
		return `${this.number}.pdf`;
	}

	public async previewPdf() {
		await previewUrl(this.pdfUrl);
	}

	public async downloadPdf() {
		await downloadUrl(this.pdfUrl, this.pdfFileName);
	}
}